export default [
    {
        name: 'AlphaCity booking platform',
        description: '',
        keywords: [],
        urls: {
            PROD: 'https://bmwde.ametras.com/login.do'
        },
        admission: {
            requirement: '',
            application: 'Registration on website'
        }
    },
    {
        name: 'AT&T',
        description: '',
        keywords: [],
        urls: {
            PROD: 'https://eod.wireless.att.com'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'CDLA ConnectedDrive Log Analyzer',
        description: 'Kibana of CSBE Logs',
        keywords: [],
        urls: {
            INT: 'https://int-b2vcockpit-eu.bmwgroup.net/app/kibana/',
            PROD: 'https://b2vcockpit-eu.bmwgroup.net/app/kibana/'
        },
        admission: {
            requirement: 'B2B INT/PROD',
            application:
                'See <a href="https://jira.bmw-carsharing.de/confluence/display/EG802/ConnectedDrive+Log+Analyzer" target="_blank">ConnectedDrive Log Analyzer</a>'
        }
    },
    {
        name: 'Confluence',
        description: 'Team collaboration and knowledge exchange on BMW on-demand mobility services',
        keywords: [],
        urls: {
            PROD: 'https://jira.bmw-carsharing.de/confluence/'
        },
        admission: {
            requirement: '',
            application: 'Create ticket in <a href="https://jira.bmw-carsharing.de/browse/AM" target="_blank">Accountmanagement project</a>'
        }
    },
    {
        name: 'CSBE EMEA',
        description: 'CarSharing Backend Europe',
        keywords: ['provisioning', 'event viewer', 'event search'],
        urls: {
            INT: 'https://csbe-int.bmwgroup.net/csbe/admin/',
            PROD: 'https://csbe.bmwgroup.net/csbe/admin/'
        },
        admission: {
            requirement: 'B2B INT/PROD',
            application: ''
        }
    },
    {
        name: 'CSBE US',
        description: 'CarSharing Backend US',
        keywords: ['provisioning', 'event viewer', 'event search'],
        urls: {
            INT: 'https://csbe-int-na.bmwgroup.net/csbe/admin/',
            PROD: 'https://csbe-na.bmwgroup.net/csbe/admin/'
        },
        admission: {
            requirement: 'B2B INT/PROD',
            application: ''
        }
    },
    {
        name: 'DriveNow booking platform',
        description: '',
        keywords: [],
        urls: {
            PROD: 'https://de.drive-now.com/#!/kunden/cockpit'
        },
        admission: {
            requirement: '',
            application: 'Registration on website'
        }
    },
    {
        name: 'FLUB',
        description: 'Flexible Use Backend',
        keywords: ['P2P', 'Sindy', 'Sally', 'FizCar'],
        urls: {
            TEST: 'https://arm-t.bmw.com/p2p-fleet-admin/#/login/home',
            INT: 'https://arm-i.bmw.com/p2p-fleet-admin/#/login/home',
            PROD: 'https://arm.bmw.com/p2p-fleet-admin/#/login/home'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'FMS',
        description: 'Fleet Management System',
        keywords: ['infleeting', 'defleeting'],
        urls: {
            INT: 'https://fmsci.bmwgroup.net/bmwfms/index.xhtml',
            PROD: 'https://fmscp.bmwgroup.net/bmwfms/index.xhtml'
        },
        admission: {
            requirement: 'B2B INT/PROD',
            application: ''
        }
    },
    {
        name: 'GSDP',
        description: '',
        keywords: [],
        urls: {
            PROD: 'https://m2mprdgui.vodafone.com/GDSPGui/login.htm'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'Hive',
        description: 'Raw data warehouse for on-demand mobility services data',
        keywords: ['booking data', 'raw data', 'SQL queries', 'vehicle events', 'client events'],
        urls: {
            INT: 'https://hue.int-bmw-carsharing.com',
            PROD: 'https://hue.bmw-carsharing.com'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'Insight',
        description: 'Data analytics Kibana for on-demand mobility services data',
        keywords: ['booking data', 'vehicle events', 'client events'],
        urls: {
            TEST: 'https://kibana.test.analytics.bmw-fleet.net',
            INT: 'https://kibana.int.analytics.bmw-fleet.net',
            PROD: 'https://kibana.prod.analytics.bmw-fleet.net'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'MQTT Broker Dashboards Grafana',
        description: '',
        keywords: ['monitoring', 'operations'],
        urls: {
            INT: 'https://monitoring-grafana.int-bmw-carsharing.com',
            PROD: 'https://monitoring-grafana.bmw-carsharing.com'
        },
        admission: {
            requirement: '',
            application: 'For login details, please contact Gordon Issac (gordon.isaac@bmw.de) or Vera Vogl (vera.vogl@bmw.de)'
        }
    },
    {
        name: 'MQTT Broker Dashboards Kibana',
        description: 'Select the environment directly in Kibana (INT/PROD).',
        keywords: ['monitoring', 'operations'],
        urls: {
            PROD: 'https://kibana.main.prod.toolops-infra.bmw-fleet.net'
        },
        admission: {
            requirement: '',
            application: 'For login details, please contact Gordon Issac (gordon.isaac@bmw.de) or Vera Vogl (vera.vogl@bmw.de)'
        }
    },
    {
        name: 'ITSM',
        description: 'BMW IT Service Management',
        keywords: [],
        urls: {
            PROD: 'https://itsmsuite.bmwgroup.net'
        },
        admission: {
            requirement: 'B2B INT/PROD',
            application: ''
        }
    },
    {
        name: 'Jira',
        description: 'Agile project management tool for BMW on-demand mobility services',
        keywords: [],
        urls: {
            PROD: 'https://jira.bmw-carsharing.de'
        },
        admission: {
            requirement: '',
            application: 'Create ticket in <a href="https://jira.bmw-carsharing.de/browse/AM" target="_blank">Accountmanagement project</a>'
        }
    },
    {
        name: 'Logan Download',
        description: 'Log Analyzer for Client logs and NAD logs; offline tool',
        keywords: ['first responder'],
        urls: {
            PROD: 'https://jira.bmw-carsharing.de/confluence/display/WIS/Support'
        },
        admission: {
            requirement: '',
            application: 'Contact EE-544'
        }
    },
    {
        name: 'Mapdesk KML Editor Download',
        description: 'KML editor for business areas, parking areas and other georeferenced data',
        keywords: [],
        urls: {
            PROD: 'https://jira.bmw-carsharing.de/confluence/pages/viewpage.action?title=Ablageort+MapDesk+und+Kartendaten&spaceKey=DOKUCS'
        },
        admission: {
            requirement: '',
            application: 'Contact EE-544'
        }
    },
    {
        name: 'Monitoring Sixt',
        description: '',
        keywords: [],
        urls: {
            PROD: 'https://monitoring.service.drive-now.com/#/dashboard/elasticsearch/BMW%20Monitoring%20X'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'On-demand mobility services Competence Base',
        description: 'Operations and Process Knowledge Base, ODM Blue print',
        keywords: ['blueprint'],
        urls: {
            PROD: 'https://jira.bmw-carsharing.de/confluence/display/CSKED/ODM+Competence+Base'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'Ridecell Dispatcher',
        description: 'Customer and fleet management platform ReachNow',
        keywords: [],
        urls: {
            PROD: 'https://drivenow.ridecell.com/dispatch'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'Sophos',
        description: '',
        keywords: [],
        urls: {
            INT: 'https://my.mcs.sophos.com',
            PROD: 'https://my.mcs.sophos.com'
        },
        admission: {
            requirement: '',
            application: ''
        }
    },
    {
        name: 'TMT',
        description: 'Template Management Tool',
        keywords: [],
        urls: {
            PROD: 'https://tmt.prod.odm.bmw-fleet.net/templatemanagement/content2/screen.xhtml'
        },
        admission: {
            requirement: '',
            application: 'Contact EE-544/Iteratec'
        }
    }
];
